var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#circle-close_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E5E7EC",
  d: "M10 19.167A9.167 9.167 0 1 1 10 .833a9.167 9.167 0 1 1 0 18.334"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#535861",
  d: "M13.622 6.504a.443.443 0 0 1-.004.627l-6.447 6.364a.443.443 0 1 1-.622-.631L12.995 6.5a.443.443 0 0 1 .627.004"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#535861",
  d: "M6.545 6.504A.443.443 0 0 1 7.17 6.5l6.447 6.364a.443.443 0 1 1-.623.63L6.55 7.132a.443.443 0 0 1-.004-.627"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "circle-close_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgCircleClose;